import React from 'react';

import FormError from "../../../../../../../core/gd-form/common/form-error/form-error";
import FormManager from "../../../../../../../core/gd-form/common/form-manager";
// @ts-ignore
import DatePicker from "../../../../../../../core/gd-form/form-element/datepicker/datepicker-new";

type Props = {
    form    : FormManager
}

export default function NewProject_StartDateSelector(props:Props) {
    return (
        <div className="row planning">
            <div className="label">Start date</div>
            <div className="element">
                <DatePicker form={props.form}
                            name="startDate"
                            placeholderText="Start date"
                            inline={true} />
                <div className="cf"></div>
                <div className="element-hint m-t-5 ui5-txt-no-accent-small lh-13em">
                    Select the start date for the first event/task. Other items will be rescheduled respectively.
                </div>

                <FormError form={props.form} name="startDate" />
            </div>
        </div>
    )
}

